import React, { Component, Fragment } from 'react'
import config from '../../../config'
import { Container, Row, Card, Jumbotron, Col, Form, Button, Table } from 'react-bootstrap'
import SearchItem from '../../subcomponent/searchItem'
import Mensajes from '../../subcomponent/mensajes'
import Menu from '../../menu'
import errores from '../../../middleware/errordb'
import { IoIosRemoveCircle } from "react-icons/io";
import { IconContext } from "react-icons";

export class transladoInventario extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            empresa: currentCompany,
            tipo: currentUserType,
            mostrarMensaje: false,
            mensaje: "",
            data_items: [],
            list_items: [],
            lista_bodegas: [],
            inventario: [],
            bodega_origen: "",
            bodega_destino: "",
            descripcion: "",
            cantidad: 1,
            proveedor: 1,
            tipoMov: "TR",
            observacion: "",
            cantidad_disponible: 0,
            fecha: ""
        }
    }

    componentDidMount() {
        this.initTraslado();
    }

    initTraslado = () => {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;

        let numero = 1;
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/inventary', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datos = data.data;
                    const consecutivos = datos[3];

                    consecutivos.forEach(element => {
                        if (element.TIPO_MOVIMIENTO === this.state.tipoMov) numero = element.NUM;
                    });

                    this.setState({
                        data_items: datos[0],
                        lista_bodegas: datos[1],
                        inventario: datos[2],
                        numero,
                        fecha: todayFormat
                    });
                } else {
                    //console.log(data);
                    this.setState({ mostrarMensaje: true, mensaje: data.message })
                }
            });
    }

    addItem = (itemSelect) => {
        const { bodega_origen } = this.state;
        let new_list_items = this.state.list_items
        let control = 0;

        new_list_items.forEach(element => {
            if (element.ID_ITEMS.toString() === itemSelect.ID_ITEMS.toString()) {
                control++;
            }
        });

        if (control === 0) {
            itemSelect.cantidad = 0;
            itemSelect.disponible = 0;
            itemSelect.observacion = "";

            new_list_items.unshift(itemSelect);
            this.setState({
                list_items: new_list_items
            });
        }
        this.updateCantidadDisponible(bodega_origen);
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const { empresa } = this.state;
        const { list_items } = this.state;
        const { cantidad } = this.state;
        const { bodega_origen } = this.state;
        const { bodega_destino } = this.state;
        const { proveedor } = this.state;
        const { tipoMov } = this.state;
        const { observacion } = this.state;
        const { numero } = this.state;

        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                empresa,
                cantidad,
                proveedor,
                tipoMov,
                observacion,
                bodega_origen,
                bodega_destino,
                numeroDoc: numero,
                item: list_items
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/inventary/transfer', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    this.setState({
                        mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente",
                        bodega_origen: "",
                        bodega_destino: "",
                        proveedor: 1,
                        observacion: "",
                        list_items: []
                    });
                    this.initTraslado();
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Transalado con errores:" + errores[data.code] + " " + data.message })
                }
            });
    }

    changeBodegaOrigen = ({ target }) => {
        this.setState({ bodega_origen: target.value });
        this.updateCantidadDisponible(target.value);
    }

    updateCantidadDisponible = (bod) => {
        const new_list_items = this.state.list_items;
        const bodega_origen = bod;

        new_list_items.forEach(element => {
            element.disponible = this.findQuantity(element.ID_ITEMS, bodega_origen);

        });

        this.setState({
            list_items: new_list_items
        });
    }

    findQuantity = (item, bodega) => {
        const { inventario } = this.state;
        for (let index = 0; index < inventario.length; index++) {
            const element = inventario[index];
            if (element.ID_BODEGA.toString() === bodega.toString() && element.ID_ITEMS.toString() === item.toString()) {
                return (element.CANTIDAD || 0);
            }

        }
        return 0;
    }

    modifyInput = ({ target }, i) => {
        let new_list_items = this.state.list_items
        new_list_items.forEach((element, index) => {
            if (index === i) {
                element[target.id] = target.value;

                if (target.id === "cantidad" && target.value < 0) {
                    element.tipo = "S";
                } else if (target.id === "cantidad" && target.value > 0) {
                    element.tipo = "E";
                } else {
                    element.tipo = "-";
                }
            }
        });

        this.setState({
            list_items: new_list_items
        });
    }

    removeitem = (index) => {
        let newData = this.state.list_items;
        newData.splice(index, 1);
        this.setState({ list_items: newData });
    }

    render() {
        const { lista_bodegas } = this.state;
        const { list_items } = this.state;
        const modifyInput = this.modifyInput;
        const removeitem = this.removeitem;
        return (
            <Fragment>
                <Menu></Menu>
                <Jumbotron className="Jumbotron">
                    <h2>Traslados</h2>
                </Jumbotron>
                <Container>
                    <Card className="card">
                        <Card.Body>
                            <Form className="form" onSubmit={this.handleSubmit}>
                                <Row>
                                    <Col sm={3}>
                                        <SearchItem data={this.state.data_items} event={this.addItem} ></SearchItem>
                                    </Col>
                                    <Col sm={9}>
                                        <Form.Control type="hidden" placeholder="Empresa" onChange={e => this.setState({ empresa: e.target.value })} value={this.state.empresa} required disabled />
                                        <Form.Row>
                                            <Form.Group as={Col} controlId="">
                                                <Form.Label>Numero</Form.Label>
                                                <Form.Control type="text" value={this.state.tipoMov + '-' + this.state.numero} required readOnly />
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="">
                                                <Form.Label>Fecha</Form.Label>
                                                <Form.Control type="text" value={this.state.fecha} readOnly />
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="">
                                                <Form.Label>Bodega Origen</Form.Label>
                                                <Form.Control as="select" onChange={this.changeBodegaOrigen} value={this.state.bodega_origen} required >
                                                    <option value="">Seleccione</option>
                                                    {
                                                        lista_bodegas.map((bodega, i) => {
                                                            return (<option key={'b' + i} value={bodega.ID_BODEGAS}>{bodega.DESCRIPCION_BODEGA}</option>)
                                                        })
                                                    }
                                                </Form.Control>
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="">
                                                <Form.Label>Bodega Destino</Form.Label>
                                                <Form.Control as="select" onChange={e => this.setState({ bodega_destino: e.target.value })} value={this.state.bodega_destino} required >
                                                    <option value="">Seleccione</option>
                                                    {
                                                        lista_bodegas.map((bodega, i) => {
                                                            if (bodega.ID_BODEGAS.toString() !== this.state.bodega_origen) {
                                                                return (<option key={'b' + i} value={bodega.ID_BODEGAS}>{bodega.DESCRIPCION_BODEGA}</option>);
                                                            } else {
                                                                return null;
                                                            }
                                                        })
                                                    }
                                                </Form.Control>
                                            </Form.Group>
                                        </Form.Row>
                                        <Form.Row>
                                            <Form.Group as={Col} controlId="">
                                                <Form.Control placeholder="Observacion" min="1" type="text" onChange={(e) => this.setState({ observacion: e.target.value })} value={this.state.observacion} />
                                            </Form.Group>
                                        </Form.Row>
                                        <div className="tableFixHead">
                                            <Table striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th>Ref.</th>
                                                        <th>Descripcion</th>
                                                        <th>Disponible</th>
                                                        <th>Cantidad</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        list_items.map((element, i) => {
                                                            return (
                                                                <tr key={'tr' + i}>
                                                                    <td>
                                                                        <IconContext.Provider value={{ size: "2em" }}>
                                                                            <IoIosRemoveCircle onClick={() => removeitem(i)} />
                                                                        </IconContext.Provider>
                                                                    </td>
                                                                    <td>{element.REFERENCIA_ITEM}</td>
                                                                    <td>{element.DESCRIPCION_ITEM}</td>
                                                                    <td>{element.disponible}</td>
                                                                    <td><Form.Control id="cantidad" className="shortinput" min="1" max={element.disponible} type="number" onChange={(e) => modifyInput(e, i)} value={element.cantidad} required /></td>
                                                                </tr>
                                                            );
                                                        })
                                                    }
                                                </tbody>
                                            </Table>
                                        </div>
                                        <Button variant="primary" type="submit" disabled={!(list_items.length > 0)} >Finalizar Documento</Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                </Container>
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </Fragment>
        )
    }
}

export default transladoInventario
